import flatMap from "lodash/flatMap";
import lastIndexOf from "lodash/lastIndexOf";
import trim from "lodash/trim";

import JsonApi from "./jsonApi";
import store from "../store";
import {
  capitalizeFirstLetters,
  getQuotePriceWithTaxes,
  getTotalPrice, toFixedPrice, sortByOrder,
} from "../misc/helpers";
import {
  setJobId,
  setDefaultInstallations,
  setFabricatorData,
  loadFilters,
  setStonePricing,
  setBathroomVisualizerPresets,
  setProjectDocumentsIds,
  loadMobileNav,
  setFabricatorTaxes, setLoadedPresets, toggleUseFabricatorCostPrices
} from "../actions/actionFunctions";

import {renderErrorPopup} from "./api-popups";
import {loaderDisable} from "../bvcomponents/ui/loaderView";
import {QuoteRequestType} from "../bvcomponents/visComponents/constants";
import * as actionTypes from '../actions/actionTypes';
import Config, {getCommonVisualizerType, IS_DEALER_FLOW, IS_QKB_UI, IS_DASHBOARD_MESSAGING} from "../config";
import {setFabricatorSubscriptions} from "../actions/initialFlowFunctions";
import {setDiscountSections, setWorkSheetsCount} from "../actions/priceWorksheetActions";
import {getCurrentReceipt, setReceiptUrl} from "../actions/printFunctions";
import {getEmployees} from "./user-api";
// import {getParsedLookUrl} from "../bvcomponents/look/lookNavigation/lookFunctions";
import {setWizardList} from "../actions/wizardFunctions";
import {setAllFeaturesLoaded, setJobIsSaving} from "../actions/serverFunctions";
import {updatePresetsArray} from "../misc/presetsFunctions";
import {fixFeaturesResponse, getCompressedCartItem} from "../misc/backendFunctions";
import {updateCurrentQuote} from "../misc/quotesFunctions";
import {getParsedWizardList} from "../bvcomponents/look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import {setMarkUpLogic} from "../actions/shoppingCartFunctions";
import {parseMarkUp} from "../misc/priceFunctions";
import {getMarkUpForFeatures} from "./features-api";
import {setResponseFeaturesGlobalUseBaseMarkUp, setResponseFeaturesMarkUp} from "../misc/markUpFunctions";
import {shouldUseContractSigning} from "../bvcomponents/popups/contractSign/contractsFunctions";
import {
  getDepositAmount,
  getPriceWorkSheetSaveValues,
  isSaveOnlyDiscount
} from "../bvcomponents/priceWorksheet/discountFunctions";
import {getDifferentCurrencyCartItems} from "../misc/misc2";
import {setDealerUserFromFabricator} from "../misc/userFunctions";
import {DISCOUNT_MAIN_TYPES} from "../bvcomponents/priceWorksheet/discounstInterface";
import {getAddressFromObject} from "../bvcomponents/popups/printPopup/printDocumentInfo";
import {getQuoteDocumentFeatures} from "../misc/quoteDocumentFeatures";
import {saveCreatedAIImage} from "../bvcomponents/ai/aiApi/aiApi";
// import featuresWorker from "../webWorkers/featuresWorker";


export const getSaveQuoteFastData = async (forTempSave = false) => {
  const state = store.getState();
  const {userState, quotesState, instState, serverState, priceWorksheetState, cartState, printState, paymentState,
    contractSigningState, fabricatorState} = state;
  let needToRevertBackCostPrices = fabricatorState.settings.useFabricatorCostPrices;
  if (needToRevertBackCostPrices && !IS_DASHBOARD_MESSAGING) {
    store.dispatch(toggleUseFabricatorCostPrices(false)); // always use retail prices
  }
  const updatedQuotes = await updateCurrentQuote();
  const totalPrice = getTotalPrice();
  const grandTotal = getQuotePriceWithTaxes(totalPrice);
  const records = updatedQuotes.map((quoteObject, quoteIndex) => {
    let record = Object.assign({}, quoteObject);
    record.bvImage = record.staticCanvasImage || record.bvImage;
    let recordData = Object.assign({}, quoteObject.data, {
      activeQuoteIndex: quotesState.activeQuoteIndex,
      contractSigningValues: contractSigningState.pagesCustomFieldsValue,
      contractsValues: contractSigningState.contractsValues,
      savedInvoiceNumberOfPages: contractSigningState.savedInvoiceNumberOfPages,
      needToUpdateContract: contractSigningState.needToUpdateContract,
      receiptSignature: printState.receiptSignature,
      receiptWorkOrderNumber: printState.receiptWorkOrderNumber,
      receiptHDLeadNumber: printState.receiptHDLeadNumber,
      receiptBathroomLocation: printState.receiptBathroomLocation,
      receiptEstimateStart: printState.receiptEstimateStart,
      receiptEstimatedText: printState.receiptEstimatedText,
      priceWorkSheetLogic: getPriceWorkSheetSaveValues(priceWorksheetState),
      roomMultiplier: quoteObject.roomMultiplier || 1,
      shippingAddress: paymentState.shippingAddress,
      billingAddress: paymentState.billingAddress,
      billingSameAsShipping: paymentState.billingSameAsShipping,
    })
    record.data = forTempSave ? recordData : JSON.stringify(recordData);
    record.sqFtCalcImage = quoteObject.sqFtCalcData ? quoteObject.sqFtCalcData.canvasImage : null;
    record.sFtCalcDataJson = quoteObject.sqFtCalcData ? JSON.stringify(
      Object.assign({}, quoteObject.sqFtCalcData, {
        canvasImage: undefined // remove canvasImage as we don't need to pass it twice
      })
    ) : null;
    delete record.sqFtCalcData;
    delete record.quoteId;
    const recordCartItems = [...cartState.cartItems.filter(ci => ci.cartFeature && ci.cartFeature.dbFeature && (ci.currentQuote === quoteIndex))]
    // record.cartItems = recordCartItems; // why do we need it here ??? that doesnt make any sense
    record.features = recordCartItems.map(ci => getCompressedCartItem(ci));
    // the documents generated from this record's images, not the priced features above
    record.documentFeatures = getQuoteDocumentFeatures(recordCartItems);
    if (forTempSave) {
      delete record.bvImage
    }
    return record
  });
  const discountSections = [...priceWorksheetState.discountSections.map(discountSection => Object.assign({}, discountSection))]
    .filter(discountSection => {
      discountSection.discounts = [...discountSection.discounts]
        .filter(discount => discount.selected)
        .map(discount => Object.assign({}, discount, { oldDeleted: undefined }));
      return discountSection.discounts.some(discount => discount.selected);
    });
  const differentCurrencyObjects = getDifferentCurrencyCartItems(fabricatorState.settings, cartState.cartItems);
  const anotherCurrencies = differentCurrencyObjects.length ? JSON.stringify(differentCurrencyObjects.map(currObject => {
    const currentTotal = getTotalPrice(null, true, currObject.cartItems);
    const total = toFixedPrice(getQuotePriceWithTaxes(currentTotal, discountSections), true)
    return {
      total,
      currency: currObject.currency,
    }
  })) : "";
  const totalWithTaxes = getQuotePriceWithTaxes(totalPrice);
  const customDeposit = +getDepositAmount(priceWorksheetState.discountSections, grandTotal, fabricatorState) || 0;
  const subTotal = getTotalPrice(null, false);

  const total = {
    subTotal: subTotal.materialPrice, // without discounts
    discountsAmount: +toFixedPrice(subTotal.materialPrice - totalPrice.materialPrice),
    materialCost: totalPrice.materialPrice,
    installationCost: totalPrice.installationPrice,
    installationTaxes: totalPrice.installationTaxes, // installation tax amount
    materialTaxes: totalPrice.materialTaxes, // material tax amount
    priceTaxes: totalPrice.priceTaxes, // all tax amount
    totalWithTaxes,
    customDeposit,
    balance: totalWithTaxes && customDeposit ? +((grandTotal - customDeposit).toFixed(2)) : totalWithTaxes,
    anotherCurrencies,
  }
  if (priceWorksheetState.discountSections.some(section => section.discounts.some(discount => {
    return discount.discountType === DISCOUNT_MAIN_TYPES.lowesIME
  }))) {
    const totalForLowesIME = getTotalPrice(null, true, null, false, true);
    total.totalForLowesIME = getQuotePriceWithTaxes(totalForLowesIME);
  } else {
    total.totalForLowesIME = totalWithTaxes;
  }
  if (needToRevertBackCostPrices && !IS_DASHBOARD_MESSAGING) {
    store.dispatch(toggleUseFabricatorCostPrices(true)); // revert back
  }
  return {
    jobId: document.kvConfig.jobId || serverState.jobId,
    fromBV: true,
    fabricatorId: document.kvConfig.userId,
    notes: [],
    documents: [],
    documentFeatures: getQuoteDocumentFeatures(), // the receipt documents cover the whole job
    employeeId: +userState.userInfo.employeeId,
    shareUrl: serverState.shareUrl,
    discountSections,
    installations: flatMap(instState.instList, i => i.services.filter(service => service.selected)),
    subId: document.subId && document.subId.toString ? document.subId.toString() : null,
    total,
    records,
    isDealerFlow: IS_DEALER_FLOW,
    customDeliveryAddress: getAddressFromObject(paymentState.shippingAddress.address1 ? paymentState.shippingAddress : userState.userInfo.shipping, true)
  };
};

export const saveQuoteFast = async () => {
  if (document.kvConfig.canSaveQuote === false || document.kvConfig.devMode || window.postMessageIsExecuting) {
    return null;
  }
  const savedFastData = await getSaveQuoteFastData();
  //console.log("save quote fast request", savedFastData);
  return JsonApi.saveQuoteFast(savedFastData)
};

/**
 * Saves the quote
 * @param submit {boolean}
 * @param yesNoConsultationRequest {boolean}
 * @param quoteRequestType {string}
 * @param fromCheckOutPage {boolean}
 * @param assignQuotePopupCustomer {object}
 * @param assignQuotePopupEmployee {object}
 * @param showContractSignOnError {boolean}
 * @param showReceipt {boolean}
 * @param skipSavingDocuments {boolean}
 * @param isDashboardJobAutoRecalculating {boolean}
 * @param dashboardAutoRecalculateResult {object}
 * @return {*}
 */
export const saveQuote = async ({
                                  submit,
                                  yesNoConsultationRequest = false,
                                  quoteRequestType = QuoteRequestType.RegularDesign,
                                  fromCheckOutPage = false,
                                  assignQuotePopupCustomer = null,
                                  assignQuotePopupEmployee = null,
                                  showContractSignOnError = false,
                                  showReceipt = true,
                                  skipSavingDocuments = false,
                                  isDashboardJobAutoRecalculating = false,
                                  dashboardAutoRecalculateResult = null,
                                }) => {
  if (document.kvConfig.canSaveQuote === false) {
    return null;
  }
  store.dispatch(setJobIsSaving(true)); // prevent rendering with price changes (cost <--> receipt issue)
  const savePhaseTimings = {};
  let savePhaseStartedAt = performance.now();
  const recordSavePhase = (phase) => {
    savePhaseTimings[phase] = Math.round(performance.now() - savePhaseStartedAt);
    savePhaseStartedAt = performance.now();
  };

  const formData = new FormData();
  const state = store.getState();
  const {userState, serverState, fabricatorState, cartState, contractSigningState, unlockCalculationsState, aiState} = state;
  const {fabricatorTaxes} = fabricatorState;
  const fabricatorSettings = fabricatorState.settings;

  const savedFastData = await getSaveQuoteFastData();
  recordSavePhase("collectQuoteData");

  let needToRevertBackCostPrices = fabricatorSettings.useFabricatorCostPrices;
  if (needToRevertBackCostPrices && !IS_DASHBOARD_MESSAGING) {
    store.dispatch(toggleUseFabricatorCostPrices(false)); // always use retail prices
  }
  if (assignQuotePopupEmployee) {
    savedFastData.employeeId = assignQuotePopupEmployee.id;
  }
  // documents already stored for this job are skipped, assigning the quote to another customer creates
  // a new job, so they are uploaded again for it. the server matches the files parts to the documents
  // by name and throws on duplicated names
  const targetJobId = +savedFastData.jobId || 0;
  const isDocumentToSave = doc => doc.uploadedForJobId !== targetJobId;
  const documentsToSave = serverState.documents.filter((doc, docIndex, docs) => isDocumentToSave(doc)
    && docs.findIndex(_doc => isDocumentToSave(_doc) && _doc.name === doc.name) === docIndex);
  const sendConsumerEmail = serverState.agreeEmailCheckbox
    && (!fabricatorSettings.sureTax || userState.isPhoneNumberValidated) && !serverState.productionSheetCheckbox;
  const data = {
    ...savedFastData,
    yesNoConsultationRequest,
    submit,
    fromCheckOutPage,
    sendConsumerEmail,
    isProductionSheet: serverState.productionSheetCheckbox,
    customerEmail: (assignQuotePopupCustomer ? assignQuotePopupCustomer.email : null) || userState.email || userState.userInfo.email,
    salesPerson: assignQuotePopupEmployee ? assignQuotePopupEmployee.fullName : userState.userInfo.salesPersonFullName,
    salesPersonEmail: userState.userInfo.salesPersonEmail,
    leadOriginatorId: (window.salesPerson ? window.salesPerson.rawVal / ( Math.floor(Math.PI * 1000)) : 0),
    postalCode: userState.userInfo.postal,
    isNewUser: !(document.kvConfig.jobId || serverState.jobId),
    state: cartState.state,
    fromTool: getCommonVisualizerType() === "kitchen"
      ? document.kvConfig.toolVersion === 5 || document.kvConfig.toolVersion === 6 ? "KV5" : "KV4"
      : document.kvConfig.toolVersion === 5 || document.kvConfig.toolVersion === 6 ? "BV5" :"BV",
    toolVersion: document.kvConfig.toolVersion,
    visualizerType: capitalizeFirstLetters(getCommonVisualizerType()),
    navigationType: document.kvConfig.navigationType,
    quoteRequestType,
    currency: fabricatorSettings.currency,
    installationTaxesRate: (fabricatorTaxes && fabricatorTaxes.laborRate) || 0, // this is always 0, as it is an array
    materialTaxesRate: (fabricatorTaxes && fabricatorTaxes.materialRate) || 0, // this is always 0, as it is an array
    notes: [],
    fromDashboard: document.kvConfig.isBackend,
    callFabricator: document.kvConfig.callFabricatorOnSave || false,
    language: serverState.language,
    documents: documentsToSave.map((d) => {
      return {
        documentId: 0, // the documents already stored for this job are filtered out, these are all new ones
        name: d.name,
        text: d.text,
        created: d.created,
        uid: d.uid,
        features: savedFastData.documentFeatures, // always the complete selection, the server replaces the stored one
        fileContent: Config.kioskStandAlone ? d.file.dataUri : null
      };
    }),
    markUpLogic: JSON.stringify(cartState.markUpLogic),
    IMEFieldsValues: contractSigningState.contractIMEFieldsValues,
  };
  if (isDashboardJobAutoRecalculating) {
    data.isRecalculated = true;
    const record = data.records?.[0];
    if (record) {
      try {
        const parsed = JSON.parse(record.data);
        parsed.dashboardAutoRecalculateResult = dashboardAutoRecalculateResult;
        record.data = JSON.stringify(parsed);
      } catch (e) {
        console.error("Failed to parse record data", e);
      }
    }
  }
  document.kvConfig.callFabricatorOnSave = false;

  if (Config.isDevMode()) {
    console.log("saveQuote request data:", data);
  }

  documentsToSave.forEach(doc => {
    formData.append("files", doc.file, doc.name);
  });

  let employeeSelected = null;
  if (data.employeeId) {
    const employeesList = userState.employeesListReceived
      ? userState.employeesList
      : await getEmployees(false) || []; // just in case, we should never reach here, because requests are in both user popups
    employeeSelected = employeesList.find(emp => +emp.id === data.employeeId);
  }
  let receipt = null, receiptCost = null;
  if (!document.kvConfig.visualizerOnly) {
    const pdfReceipt = await getCurrentReceipt(assignQuotePopupCustomer, employeeSelected);
    receipt = await pdfReceipt.toBlob();
    formData.append("receipt", receipt, serverState.productionSheetCheckbox ? "ProductionSheet.pdf" : "");
    recordSavePhase("renderReceipt");
  }
  const needToSaveCostReceipt = needToRevertBackCostPrices || (fabricatorState.receiptSettings && fabricatorState.receiptSettings.createCostReceipt);
  if (needToSaveCostReceipt && !IS_DASHBOARD_MESSAGING) {
    store.dispatch(toggleUseFabricatorCostPrices(true)); // switch to cost
    const totalPriceCost = getTotalPrice();
    data.total.fabricatorCostTotal = getQuotePriceWithTaxes(totalPriceCost);
    const pdfReceipt2 = await getCurrentReceipt(assignQuotePopupCustomer, employeeSelected);
    receiptCost = await pdfReceipt2.toBlob();
    formData.append("receiptCost", receiptCost);
    recordSavePhase("renderCostReceipt");
    // console.log("receiptCost", receiptCost);
    store.dispatch(toggleUseFabricatorCostPrices(false)); //the cost receipt is saved, back to retail
  }

  formData.append('json', JSON.stringify(data));
  recordSavePhase("serializePayload");
  console.debug("saveQuote: ms spent before the request", savePhaseTimings);

  return JsonApi.saveQuote(document.kvConfig.kioskMode ? data : formData, skipSavingDocuments)
    .then(async (response) => {
      const responseData = typeof response.data === 'object' ? response.data : JSON.parse(response.data);
      if (aiState.aiResults && aiState.aiResults[0] && aiState.aiResults[0].resultImageUrl && !document.kvConfig.jobId) {
        // await saveCreatedAIImage(responseData.jobId, aiState); // removed await to prevent blocking the UI
        saveCreatedAIImage(responseData.jobId, aiState)
          .catch(err => console.error("Failed to save AI image", err));
      }

      document.kvConfig.jobId = responseData.jobId;
      store.dispatch(setJobId(responseData.jobId));

      if (responseData.documents && responseData.documents.length) {
        store.dispatch(setProjectDocumentsIds(responseData.documents, responseData.jobId));
      }

      const showContractSignPopup = shouldUseContractSigning(fabricatorSettings, contractSigningState.contractsList);

      const showLeadCaptureShoppingCart = fabricatorSettings.leadCaptureShoppingCart && !unlockCalculationsState.unlockCalculationsTutorialIsFinished;
      const showDepositPopup = fabricatorSettings.enableDeposit && (!fabricatorSettings.leadCaptureShoppingCart || unlockCalculationsState.unlockCalculationsTutorialIsFinished)

      let receiptUrl = "";
      if (receipt) {
        // The receipt prints the job number, which a brand-new job only has after this save, so it has to be
        // rendered again then. For an existing job nothing the PDF reads has changed since the upload, and a
        // render is the most expensive step of the whole save, so the uploaded blob is reused as-is.
        const jobIdAssignedBySave = Number(data.jobId) !== Number(responseData.jobId);
        if (jobIdAssignedBySave) {
          const pdfReceipt = await getCurrentReceipt(assignQuotePopupCustomer, employeeSelected);
          receipt = await pdfReceipt.toBlob();
        }
        receiptUrl = URL.createObjectURL(receipt);
      }

      if (receipt && showReceipt && !showDepositPopup && !showLeadCaptureShoppingCart && !needToRevertBackCostPrices
        && (!showContractSignPopup || contractSigningState.signedDocumentUrl) && !fabricatorSettings.hasPaymentGateway) {
        window.open(receiptUrl, "_blank");
        responseData.receiptPrinted = true;
      }
      store.dispatch(setReceiptUrl(receiptUrl)); // always remember the URL (in case it is needed)

      responseData.total = data.total;

      if (needToRevertBackCostPrices && !IS_DASHBOARD_MESSAGING) {
        store.dispatch(toggleUseFabricatorCostPrices(true)); //the retail receipt is saved, back to cost
        if (receiptCost) {
          window.open(URL.createObjectURL(receiptCost), "_blank");
          responseData.receiptPrinted = true;
        }
      }
      store.dispatch(setJobIsSaving(false)); // allow rendering again

      return responseData;
    })
    .catch(error => {
      const retryFunction = saveQuote.bind(this, {
        submit,
        yesNoConsultationRequest,
        quoteRequestType,
        fromCheckOutPage,
        assignQuotePopupCustomer,
        assignQuotePopupEmployee,
      });
      renderErrorPopup("Server "+new Error(error), "", retryFunction, showContractSignOnError);
      loaderDisable();
      store.dispatch(setJobIsSaving(false)); // allow rendering again
      throw new Error(error);
    })
};

export const loadFiltersOnly = async () => {
  const response = await JsonApi.getFilterGroups();
  if (Config.isDevMode()) {
    console.log("loadFiltersOnly", response);
  }
  if (response && Array.isArray(response.data)) {
    store.dispatch(loadFilters(response.data));
  }
  return Promise.resolve()
}

export const getBathroomVisualizerData = (featuresToReceive = 30, loadVisualizerOnly = false, forVisualizer) => {
  return JsonApi.getBathroomVisualizerData(featuresToReceive, forVisualizer)
    .then(async responseData => {
      // console.log('responseData', responseData.data);
      if (!responseData.data || responseData.data.error) {
        const errorMessage = !responseData.data ? "No response data received" : responseData.data.error;
        renderErrorPopup("Server error: "+errorMessage);
        loaderDisable();
        throw new Error(errorMessage);
      } else {
        if (!loadVisualizerOnly) {
          store.dispatch(loadFilters(responseData.data.filterGroups || []));
          // store.dispatch(setFabricatorData(responseData.data.fabricatorData)); // we set it in the subscriptions response
          store.dispatch(setDefaultInstallations(responseData.data.installations));
          if (responseData.data.features) {
            const dbFeaturesArray = fixFeaturesResponse(responseData.data);
            await updateFeaturesWithMarkUp(dbFeaturesArray)
          }
        }
        store.dispatch(setStonePricing(responseData.data.stonePricing));
        if (responseData.data.defaults) {
          responseData.data.defaults = updatePresetsArray(responseData.data.defaults, forVisualizer);
          // const {lookIdFromUrl} = getParsedLookUrl(); // why do we need that?? set the same lookId on each preset? really?
          // if (lookIdFromUrl) {
          //   presets = presets.map(preset => {
          //     preset.lookId = lookIdFromUrl;
          //     return preset
          //   })
          // }
          store.dispatch(setBathroomVisualizerPresets(responseData.data.defaults, forVisualizer));
        }
        if (responseData.data.wizardData || responseData.data.wizardDataV2) {
          const wizardList = getParsedWizardList(responseData.data, false, forVisualizer);
          responseData.data.wizardList = wizardList;
          store.dispatch(setWizardList(wizardList));
        }
        //store.dispatch(setBathroomVisualizerFeatures(responseData.data.features));
        // this causes bathroomVisualizer to be super slow.... how to store huge arrays in redux store? No answer for now
        // for now, features are kept in layout dataObject.... sad, but at least it works much faster

        if (featuresToReceive === 100000) { // this is download all features functionality which is not used
          store.dispatch(setAllFeaturesLoaded(document.kvConfig.visualizerType));
          store.dispatch(setLoadedPresets(responseData.data.defaults.map(preset => preset.id)));
        }

        return responseData.data
      }
    })
    .catch((error) => {
      loaderDisable();
      console.log('getBathroomVisualizerData', error);
    });
};

export const getJobIdPreset = (jobId, editToken) => {
  return JsonApi.getBVJobData(jobId, editToken);
};

const skipRequestsFor = ["Attachment", "Decor", "Decore"];

export const shouldRequestMarkUpForFeatures = (featuresResponse) => {
  return featuresResponse && Array.isArray(featuresResponse)
    && featuresResponse.length
    && !featuresResponse.every(dbFeature => dbFeature.groupName
      && (skipRequestsFor.includes(dbFeature.groupName) || dbFeature.groupName.includes("Crop")))
}

const updateFeaturesWithMarkUp = async (featuresResponse) => {
  const storeState = store.getState();
  if (!shouldRequestMarkUpForFeatures(featuresResponse)) {
    return featuresResponse
  }
  featuresResponse = setResponseFeaturesGlobalUseBaseMarkUp(featuresResponse, storeState);
  if (storeState.fabricatorState.settings.useMarkUpFeaturesRequests) {
    const markUpResponse = await getMarkUpForFeatures(featuresResponse);
    setResponseFeaturesMarkUp(featuresResponse, markUpResponse, storeState, false);
  }
  return featuresResponse
}

export const getBvFeatures = async (arrayOfIds,
                                    arrayOfSkus = null,
                                    requestSharedFeatureNames = false,
                                    forVisualizer,
                                    searchString = "",
                                    axiosController = null,
                                    getOnlyGroupNames = null,
                                    needToCacheResponse = false) => {
  const featuresResponse = await JsonApi.getBathroomVisualizerFeatures(
    arrayOfIds,
    arrayOfSkus,
    requestSharedFeatureNames,
    forVisualizer,
    searchString,
    axiosController,
    getOnlyGroupNames,
    needToCacheResponse,
  );
  if (featuresResponse && Array.isArray(featuresResponse.data) && !featuresResponse.markUpAlreadySet) {
    await updateFeaturesWithMarkUp(featuresResponse.data)
  }
  return featuresResponse
};

export const getBvGroups = (visualizerType) => {
  return JsonApi.getBathroomVisualizerGroups(visualizerType)
};

/**
 * Main request to get features for feature group
 * @param groupName {string}
 * @param page {number}
 * @param pageSize {number}
 * @param filterValues {array}
 * @param searchText {string}
 * @param layoutAbbreviation {string}
 * @param axiosController {object}
 * @param requestOldFeatures {boolean}
 * @param visualizerType {string}
 * @returns {Promise<{data: []}>}
 */
export const getBvGroupFeatures = async (groupName, page, pageSize, filterValues, searchText = "", layoutAbbreviation, axiosController, requestOldFeatures, visualizerType) => {
  const featuresResponse = await JsonApi.getBathroomVisualizerGroupFeatures(groupName, page, pageSize, filterValues, searchText, layoutAbbreviation, axiosController, requestOldFeatures, visualizerType)
  if (featuresResponse && Array.isArray(featuresResponse.data) && !featuresResponse.markUpAlreadySet) {
    await updateFeaturesWithMarkUp(featuresResponse.data)
  }
  return featuresResponse.data
};
export const getBvGroupFilterValues = async (groupName, filterId, withStoneFilters) => {
  const filterResponse = await JsonApi.getBathroomVisualizerGroupFilterValues(groupName, filterId, withStoneFilters);
  console.log("filterResponse:", filterResponse);
  if (filterResponse.data.error) {
    const {error} = filterResponse.data;
    renderErrorPopup(error);
    return {data: []}
  }
  return filterResponse
};

export const submitPayment = (paymentInfo, useNewHoc = false) => { // submit is used in the WithPaymentSubmit HOC, all info is there
  const state = store.getState();
  const {serverState} = state;
  return JsonApi.submitPayment(useNewHoc ? paymentInfo : {
    ...paymentInfo,
    country: paymentInfo.country.name,
    fabricatorId: document.kvConfig.userId,
    jobId: document.kvConfig.jobId || serverState.jobId
  })
    .then(response => {
      store.dispatch({
        type: actionTypes.SUBMIT_PAYMENT_RESPONSE, // why do we need it? not used at all
        payload: response.data
      });
      if (useNewHoc) {
        const res = response.data;
        if (res.transactionResponse && res.transactionResponse.responseCode === '1') {
          // showQuoteSavedNotification();
          window.checkoutSuccess = true;
          const receiptUrl = store.getState().printState.receiptUrl;
          if (receiptUrl) {
            window.open(receiptUrl, "_blank");
          }
        } else {
          let msg = '';
          if (res && (res.transactionResponse && res.transactionResponse.errors && res.transactionResponse.errors.length > 0) || res.error) {
            msg = res.transactionResponse.errors[0].errorText || res.error;
          } else if (res && res.message && res.message.messageDetails.length > 0) {
            msg = res.message.messageDetails[0].text;
          }

          let sepIdx = lastIndexOf(msg, '-');
          if (sepIdx >= 0) {
            msg = trim(msg.substr(sepIdx + 1));
          }

          renderErrorPopup(msg, "Card Error");
        }
      }
      return response.data;
    })
    .catch(error => {
      renderErrorPopup("Server "+new Error(error));
      loaderDisable();
      throw new Error(error);
    })
};

export const getQtCategories = (layoutName, visualizerType) => {
  return JsonApi.getQtCategories(layoutName, visualizerType)
    .then(response => {
      if (!response.data || response.data.error || !Array.isArray(response.data)) {
        // store.dispatch(setQtCategories([]));
        console.error("get bvPresets error: No response data received");
        return [];
      } else {
        const qtCategories = response.data.filter(qtCategory => {
          if (qtCategory.useWizard && IS_QKB_UI) {
            return true
          }
          return (qtCategory.name !== "All") && Array.isArray(qtCategory.featureGroups) && qtCategory.featureGroups.length
        });
        if (Config.isDevMode()) {
          console.log('qtCategories-->', qtCategories);
        }
        // store.dispatch(setQtCategories(qtCategories)); // with features inside featureGroups it becomes HUUUGE
        return qtCategories
      }
    })
    .catch(error => {
      renderErrorPopup("Server "+new Error(error));
      loaderDisable();
      throw new Error(error);
    })
};

export const getFabricatorSubscriptions = (fabricatorId = document.kvConfig.userId) => {
  return JsonApi.getFabricatorSubscriptions(fabricatorId)
    .then(response => {
      if (!response || !response.data || response.data.error) {
        console.error("getFabricatorSubscriptions error: No response data received");
      } else {
        if (Config.isDevMode()) {
          console.log("response getFabricatorSubscriptions", response);
        }
        if (Array.isArray(response.data.subscriptions)) {
          store.dispatch(setFabricatorSubscriptions(response.data.subscriptions));
        }
        if (document.kvConfig.isCaesarStone && response.data.fabricatorData
          && response.data.fabricatorData.fabricatorName === "QC Master Account CAN") {
          response.data.fabricatorData.wasCreatedFromFabricator = "QC Master Account CAN";
        }
        const globalMarkUp = response.data.fabricatorData && response.data.fabricatorData.globalMarkUp
          ? parseMarkUp(response.data.fabricatorData.globalMarkUp)
          : "";
        if (globalMarkUp) {
          store.dispatch(setMarkUpLogic(globalMarkUp)) // also it can be restored with the cartState on job open
        }
        store.dispatch(setFabricatorTaxes(response.data.fabricatorTaxes));
        store.dispatch(setFabricatorData(response.data.fabricatorData));
        if (IS_DEALER_FLOW) {
          setDealerUserFromFabricator(response.data.fabricatorData);
        }
        // featuresWorker.initializeFeaturesWorker();
      }
    })
    .catch(error => {
      // console.error(+new Error(error));
      renderErrorPopup("Server Error. Check Subscription Status. \n"
        + (error?.response?.data?.error || error), "", getFabricatorSubscriptions.bind(this, fabricatorId));
      loaderDisable();
      throw new Error(error);
    })
};

export const getDiscounts = (fabricatorId = document.kvConfig.userId) => {
  return JsonApi.getFabricatorDiscounts(fabricatorId)
    .then(response => {
      if (!response || !response.data || response.data.error) {
        console.error("getFabricatorDiscounts error: No response data received");
      } else {
        console.log("response getFabricatorDiscounts", response);
        if (Array.isArray(response.data)) {
          const discountSections = response.data
            .map(discountSection => {
              discountSection.discounts = Array.isArray(discountSection.discounts)
                ? discountSection.discounts.filter(dis => dis.enabled)
                : [];
              discountSection.discounts = discountSection.discounts.map(discount => {
                if (isSaveOnlyDiscount(discount)) {
                  discount.selected = true;
                }
                return discount
              })
              discountSection.discounts = sortByOrder(discountSection.discounts);
              return discountSection
            })
            .filter(discountSection => discountSection.discounts.length);
          const sortedSections = sortByOrder(discountSections);
          store.dispatch(setDiscountSections(sortedSections));
          store.dispatch(setWorkSheetsCount(sortedSections));
        }
      }
    });
};

export const getNavigationButtons = (testConnection = false, tryOnly = false) => {
  let forTool = "";
  switch(getCommonVisualizerType()) {
    case "bathroom":
      forTool = "bv";
      break;
    case "kitchen":
      forTool = "kv";
      break;
    default:
      return []
      // forTool = document.kvConfig.visualizerType;
      // break;
  }
  return JsonApi.getMenuNavigation(forTool, testConnection)
    .then(menuData => {
      if (document.kvConfig.kioskMode || testConnection) {
        return false
      }
      store.dispatch(loadMobileNav(menuData.data));
      return menuData
    })
    .catch(error => {
      if (testConnection && !tryOnly) {
        renderErrorPopup(error, "", getNavigationButtons.bind(this, true));
      }
      return error
    });
};

export const copySqftImagesToAnotherJob = (fabricatorId = document.kvConfig.userId, postData) => {
  return JsonApi.copySqftImages(fabricatorId, postData)
    .then(response => response.data)
    .catch(error => {
      renderErrorPopup("Server "+new Error(error));
      loaderDisable();
      throw new Error(error);
    })
};
